module.exports = __webpack_public_path__ + "img/help4.51e95adb.png";